import { render, staticRenderFns } from "./ModularView.vue?vue&type=template&id=657bdf98"
import script from "./ModularView.vue?vue&type=script&lang=js"
export * from "./ModularView.vue?vue&type=script&lang=js"
import style0 from "./ModularView.vue?vue&type=style&index=0&id=657bdf98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports